<div class="flex justify-content-between align-items-center mt-3">

    <div>
        <p-button (onClick)="addCustomerProduct()" label="Add" icon="pi pi-plus" size="small"></p-button>
        <p-button (onClick)="delete()" [disabled]="selected && selected.length == 0" label="Remove" class="p-button-outlined ml-2 " icon="pi pi-trash" severity="danger" size="small" ></p-button>

    </div>

    <!-- <div class="fixed-search-container flex align-items-center justify-content-center flex-grow-1">
      <span class="p-input-icon-left">
          <i class="pi pi-search"></i>
          <input pInputText type="text" [(ngModel)]="searchKey"   placeholder="Search" class=" p-inputtext-sm" (keyup.enter)="search()"/>
      </span>
      <p-button icon="pi pi-search" (onClick)="search()" [style]="{'margin': '5px 5px 5px 5px', 'height': '35px', 'line-height': '50px'}" [raised]="true" [size]="'small'" severity="info"></p-button>
  </div> -->

  <div class="flex">
      <div class="flex align-items-center">
          <p-button icon="pi pi-refresh" size="small" (onClick)="refreshData()" [rounded]="true" severity="info"></p-button>
      </div>
  </div>

</div>

<p-table #dt1 [value]="list" [scrollable]="true" scrollHeight="613px" styleClass="p-datatable-striped" scrollHeight="630px" [loading]="loader"
    responsiveLayout="scroll" class="w-full m-5" styleClass="p-datatable-sm " [paginator]="true" [rows]="10" [(selection)]="selected" paginatorDropdownAppendTo="body"
     [rowsPerPageOptions]="[5,10 ,15, 20]" (onPage)="load($event)" [rowHover]="true">

    <ng-template pTemplate="header">
        <tr>
            <th><p-tableHeaderCheckbox></p-tableHeaderCheckbox></th>
            <th>Customer Product Code</th>
            <th>Product Code</th>
            <th>Description</th>
            <th>Last Invoice No</th>
            <th>Invoice Date </th>
            <th>Last Qty </th>
            <th>Last UOM </th>
            <th>Last Price </th>

        </tr>
    </ng-template>
    <ng-template pTemplate="body" let-data>
        <tr>
            <td> <p-tableCheckbox [value]="data"></p-tableCheckbox> </td>
            <td>{{data.customerProductCode}}</td>
            <td>{{data.productCode}}</td>
            <td>{{data.productName}}</td>
            <td>{{data.salesOrderNumber}}</td>
            <td>{{data.invoiceDate | date: 'dd/MM/yy'}}</td>
            <td>{{data.shipedQuantity | number: '1.2-2'}}</td>
            <td>{{data.uom}}</td>
            <td>{{data.unitPrice | number: '1.2-2'}}</td>

        </tr>
    </ng-template>
    <ng-template pTemplate="emptymessage">
        <tr>
            <td colspan="9">No Records found.</td>
        </tr>
    </ng-template>

</p-table>
<p-confirmDialog/>